// export const ConvertUTCtoLocal = (date, time, dateTime) => {
//   // Combine the date and time into a single string (UTC time)
//   const combinedDatetime = `${date}T${time}Z`; // The "Z" at the end indicates UTC

//   // Create a new Date object, which will be in UTC
//   const utcDate = new Date(combinedDatetime);

//   // Convert to the system's local time zone
//   const localDate = utcDate.toLocaleString(); // Full local date and time

//   // Local date only (without time)
//   const localDateOnly = utcDate.toLocaleDateString(); // Local date only

//   // Local time only (without date)
//   const localTimeOnly = utcDate.toLocaleTimeString("en-US", {
//     timeZoneName: "short", // Short time zone format (e.g., GMT-4)
//   }); // Local time only

//   // Full local date and time with time zone information
//   const localDateWithTimeZone = utcDate.toLocaleString("en-US", {
//     timeZoneName: "short", // Short time zone format (e.g., GMT-4)
//   });

//   return {
//     date: localDateOnly,
//     time: localTimeOnly,
//     dateTime: localDateWithTimeZone,
//   };
// };

export const ConvertUTCtoLocal = (date, time, dateTime) => {
  // Combine the date and time into a single string (UTC time)
  const combinedDatetime = `${date}T${time}Z`; // The "Z" at the end indicates UTC

  // Create a new Date object, which will be in UTC
  const utcDate = new Date(combinedDatetime);

  // Convert to the system's local time zone
  const localDate = utcDate.toLocaleDateString(); // Local date only

  // Local time only (without date) and without seconds
  const localTimeOnly = utcDate.toLocaleTimeString("en-US", {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true, // 12-hour format
  }); // Local time only, no seconds, 12-hour format

  // Full local date and time with time zone information, but without seconds and time zone
  const localDateWithTimeZone = `${localDate}, ${localTimeOnly}`;

  return {
    date: localDate,
    time: localTimeOnly,
    dateTime: localDateWithTimeZone,
  };
};



export const isSubscriptionActive = (user) => {
  const now = new Date();

  const source = Array.isArray(user?.subscriptions) && user.subscriptions.length > 0
    ? user.subscriptions
    : (user?.subscription ? [user.subscription] : []);

  // ✅ Check for active subscription(s) (new array or legacy object)
  const hasActiveSubscription = source.some((sub) => {
    if (!sub?.isSubscription ) return false;
    const expirationDate = sub.expirationDate ? new Date(sub.expirationDate) : null;
    return !expirationDate || expirationDate > now;
  });

  if (hasActiveSubscription) return true;

  // ✅ Check for active corporate program (lifetime — no expiration)
  const hasCorporateProgram = user?.programPurchased?.some(
    (el) => el.isCorporate === true || el.isCorporate === "true"
  );


  if (hasCorporateProgram) {
    return true;
  }

  return false;
};

/**
 * verifyOtp field `dayFirstLogin`: backend uses 0 / false when the first-login offer
 * is still pending (show modal). Uses 1 / true after onboarding is done (hide modal).
 */
export const isDayFirstLoginOfferPending = (value) =>
  value === false || value === 0 || value === "0";
